import React from "react"
const Loader = props => {
  return (
    <svg id="hearth" version="1.1" viewBox="0 0 528 512">
      <linearGradient id="lg" x1="0.5" y1="1" x2="0.5" y2="0">
        <stop offset="0%" stopOpacity="1" stopColor="#f96e67" />
        <stop offset="40%" stopOpacity="1" stopColor="#f96e67">
          <animate
            attributeName="offset"
            values="0;1;0"
            repeatCount="indefinite"
            dur="2s"
            begin="0s"
          />
        </stop>
        <stop offset="40%" stopOpacity="0.25" stopColor="#f96e67">
          <animate
            attributeName="offset"
            values="0;1;0"
            repeatCount="indefinite"
            dur="2s"
            begin="0s"
          />
        </stop>
        <stop offset="100%" stopOpacity="0.25" stopColor="#f96e67" />
      </linearGradient>
      <path
        id="right-half"
        d="m 264.02297,0 61.72118,61.818 C 438.8301,161.986 528,241.328 528,346.681 c 0,93.042 -72.75659,165.908 -165.6509,165.908 -34.9095,0 -69.48051,-11.1 -98.34112,-30.846 z m 0.001,350.681 34.67685,41.049 c 15.54962,18.428 39.95092,29.855 63.65426,29.855 42.62591,0 74.76358,-32.205 74.76358,-74.905 0,-61.565 -65.58337,-122.79 -172.61941,-217.628 L 264,128.625 Z"
        fill="url(#lg)"
        stroke="transparent"
        strokeWidth="2"
        strokeOpacity="0.75"
      />
      <path
        id="left-half"
        d="M 263.97703,0 202.25584,61.818 C 89.169902,161.986 0,241.328 0,346.681 c 0,93.042 72.756585,165.908 165.65089,165.908 34.9095,0 69.48052,-11.1 98.34112,-30.846 z m -9.9e-4,350.681 -34.67686,41.049 c -15.54961,18.428 -39.95093,29.855 -63.65428,29.855 -42.6259,0 -74.763571,-32.205 -74.763571,-74.905 0,-61.565 65.583371,-122.79 172.619421,-217.628 L 264,128.625 Z"
        fill="url(#lg)"
        stroke="transparent"
        strokeWidth="2"
        strokeOpacity="0.75"
      />
    </svg>
  )
}

export default Loader
